/**
 * 
 * @returns array<string>, format 'yyyy'
 * example ['1960', '1961', '1962']
 * 
 */
export const generateYearsOptions = ():string[] => {
  const start = new Date().getFullYear();
  const end = 1960;
  const yearsList = [];
  for (let i = start; i >= end; i--) {
    yearsList.push(i.toString());
  }

  return yearsList;
};
